import "./NotificationStyles.scss";

import React, { memo, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocalStorage } from "usehooks-ts";

import { InfoIcon } from "../../../../components/icons";
import type { IOrganization } from "../../../../contexts/organizations/organizationsContext";

export interface IProps {
  currentOrganization?: IOrganization | null;
  trackingDate: number;
}

const date =
  process.env.REACT_APP_WEB_ENV === "production"
    ? "August 1st, 2024"
    : "June 1st, 2024";

const Notification: React.FC<IProps> = memo(
  ({ currentOrganization, trackingDate }) => {
    const [isHidden, setIsHidden] = useState(false);
    const [seenNotification, setValue] = useLocalStorage(
      "seenNotification",
      "",
    );

    useEffect(() => {
      if (!seenNotification) {
        setIsHidden(false);
      }
    }, [seenNotification]);

    const handleDismiss = () => {
      setIsHidden(true);
      setTimeout(() => {
        if (seenNotification) {
          setValue(
            JSON.stringify([
              ...JSON.parse(seenNotification),
              currentOrganization?.id,
            ]),
          );
          return;
        }
        setValue(JSON.stringify([currentOrganization?.id]));
      }, 200);
    };

    if (
      (seenNotification &&
        JSON.parse(seenNotification).includes(currentOrganization?.id)) ||
      Number(currentOrganization?.created) * 1000 > trackingDate
    ) {
      return null;
    }

    return (
      <div
        data-testid="notification"
        className={`overview-notification ${isHidden ? "hide" : ""}`}
      >
        <div className="d-flex">
          <span>
            <InfoIcon />
          </span>
          &nbsp; The dashboard displays data starting from {date}. There is no
          data available prior to that.
        </div>
        <Button
          variant="primary"
          className="notification-close"
          onClick={handleDismiss}
        >
          Dismiss
        </Button>
      </div>
    );
  },
);

export { Notification };
